import { LogMapper } from './mappers/base'

export class TrainingActivityMapper extends LogMapper {
  static rows = ['logbook']
  static specialty = 'trainingActivity'
  static columns = ['scope']

  static components = {
  }
}

